import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import TableTemplete from "../Helper/TableTemplet/TableTemplet";
import { getFeeTiers, updateFeeTiersInDB } from "./FeeTiersUtils";

const columns = [
  {
    id: "product_type",
    label: "Product type",
    minWidth: 100,
    edit: false,
    type: "text",
  },
  {
    id: "product_size_tier",
    label: "Product size tier",
    edit: false,
    type: "text",
  },
  {
    id: "shipping_weight_min",
    label: "Shipping weight min",
    edit: true,
    type: "number",
  },
  {
    id: "shipping_weight_max",
    label: "Shipping weight max",
    edit: true,
    type: "number",
  },
  { id: "unit_of_shipping_weight", label: "Unit", edit: true, type: "text" },
  {
    id: "fee_per_unit_basic",
    label: "Fee per unit basic",
    edit: true,
    type: "number",
  },
  { id: "plus_unit", label: "Plus unit", edit: true, type: "number" },
  { id: "above_first", label: "Above first", edit: true, type: "number" },
];

const FeeTiers = () => {
  const dispatch = useDispatch();
  let feeTiersData = useSelector((state: any) => state.tiers.fee_tiers);

  useEffect(() => {
    if (!feeTiersData.length) getFeeTiers(dispatch);
  }, []);

  const saveChangesInDB = async (item) => {
    updateFeeTiersInDB(dispatch, item);
  };

  return (
    <div>
      <h2>Calculate Fee Tiers</h2>
      <TableTemplete
        columns={columns}
        data={feeTiersData}
        saveChangesInDB={saveChangesInDB}
      ></TableTemplete>
    </div>
  );
};

export default FeeTiers;
